const STYLES = {
  actif: ["Actif", "bg-green-50 text-green-800 border-green-200"],
  suspendu: ["Suspendu", "bg-red-50 text-red-800 border-red-200"],
  en_attente: ["En attente", "bg-amber-50 text-amber-800 border-amber-200"],
  valide: ["Validé", "bg-green-50 text-green-800 border-green-200"],
  brouillon: ["Brouillon", "bg-stone-100 text-stone-700 border-stone-200"],
  publie: ["Publié", "bg-green-50 text-green-800 border-green-200"],
  prevu: ["Prévu", "bg-amber-50 text-amber-800 border-amber-200"],
  confirme: ["Confirmé", "bg-orange-50 text-orange-800 border-orange-200"],
  termine: ["Terminé", "bg-green-50 text-green-800 border-green-200"],
  annule: ["Annulé", "bg-red-50 text-red-800 border-red-200"],
  suspect: ["Suspect", "bg-amber-50 text-amber-800 border-amber-200"],
  gueri: ["Guéri", "bg-green-50 text-green-800 border-green-200"],
  deces: ["Décès", "bg-stone-800 text-white border-stone-800"],
  active: ["Active", "bg-orange-50 text-orange-800 border-orange-200"],
  terminee: ["Terminée", "bg-stone-100 text-stone-700 border-stone-200"],
  info: ["Information", "bg-sky-50 text-sky-800 border-sky-200"],
  vigilance: ["Vigilance", "bg-amber-50 text-amber-800 border-amber-200"],
  alerte: ["Alerte", "bg-red-50 text-red-800 border-red-200"],
  REQUESTED: ["Demandé", "bg-amber-50 text-amber-800 border-amber-200"],
  CONFIRMED: ["Confirmé", "bg-orange-50 text-orange-800 border-orange-200"],
  CANCELLED: ["Annulé", "bg-red-50 text-red-800 border-red-200"],
  COMPLETED: ["Terminé", "bg-green-50 text-green-800 border-green-200"],
  SCHEDULED: ["Prévu", "bg-amber-50 text-amber-800 border-amber-200"],
  ADMINISTERED: ["Administré", "bg-green-50 text-green-800 border-green-200"],
  DONE: ["Fait", "bg-green-50 text-green-800 border-green-200"],
  MISSED: ["Manqué", "bg-red-50 text-red-800 border-red-200"],
  APPROVED: ["Validé", "bg-green-50 text-green-800 border-green-200"],
  PENDING: ["En attente", "bg-amber-50 text-amber-800 border-amber-200"],
  REJECTED: ["Refusé", "bg-red-50 text-red-800 border-red-200"],
  PARENT: ["Parent", "bg-orange-50 text-orange-800 border-orange-200"],
  DOCTOR: ["Médecin", "bg-teal-50 text-teal-800 border-teal-200"],
  ADMIN: ["Admin app", "bg-stone-800 text-white border-stone-800"],
  FULL_ACCESS: ["Accès complet", "bg-orange-50 text-orange-800 border-orange-200"],
  depasse: ["Seuil dépassé", "bg-red-50 text-red-800 border-red-200"],
  proche: ["Proche du seuil", "bg-amber-50 text-amber-800 border-amber-200"],
  normal: ["Normal", "bg-green-50 text-green-800 border-green-200"],
};

export const statusLabel = (s) => (STYLES[s] ? STYLES[s][0] : s);

export const StatusBadge = ({ value, testId }) => {
  const [label, cls] = STYLES[value] || [value, "bg-stone-100 text-stone-700 border-stone-200"];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${cls}`}>
      {label}
    </span>
  );
};
